import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'dynamic-cards-search-page.github-branch-result.label',
		defaultMessage: 'Branch',
		description: 'GitHub branch label',
	},
});
